import { render } from "./RecommendationSettings.vue?vue&type=template&id=fac7f290&scoped=true"
import script from "./RecommendationSettings.vue?vue&type=script&lang=js"
export * from "./RecommendationSettings.vue?vue&type=script&lang=js"

import "./RecommendationSettings.vue?vue&type=style&index=0&id=fac7f290&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fac7f290"]])

export default __exports__